"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Tabs = function (_a) {
    var methods = _a.methods, method = _a.method, setMethod = _a.setMethod;
    var t = (0, next_intl_1.useTranslations)('translation');
    var config = (0, swr_hooks_1.useConfig)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.methods) }, methods.map(function (m) { return (react_1.default.createElement("div", { key: m.name || m.label, className: "".concat(styles_module_scss_1.default.method, " ").concat(styles_module_scss_1.default[m.key], " ").concat(m.stroke ? styles_module_scss_1.default.stroke : '', " ").concat(method === m.key ? styles_module_scss_1.default.active : ''), onClick: function () { return setMethod(m.name || m.key || m.label); } },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.customIcon }),
            react_1.default.createElement(m.Icon, null),
            " ",
            m.label)); })),
        (config === null || config === void 0 ? void 0 : config.supportBtnInHeader) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.supportButtonWrapperInHeader },
            react_1.default.createElement(ui_components_1.SupportButton, { text: t('needHelpQuestion') }))) : null));
};
exports.default = Tabs;
